<template>
  <ParagraphBody
    bodySize="small"
    :class="$style.text"
  >
    Don't see your country? JumpCloud may be restricted from doing business with certain countries.
    <a
      href="https://jumpcloud.com/legal"
      rel="noopener noreferrer"
      target="_blank"
    >
      Learn more.
    </a>
  </ParagraphBody>
</template>

<script>
import { ParagraphBody } from '@jumpcloud/ui-components';

export default {
  name: 'CountryInformation',

  components: {
    ParagraphBody,
  },
};
</script>

<style module scoped>
  .text.text {
    margin-bottom: var(--jc-spacer-medium);

    /* legacy fix for variable font size on ios/safari */
    -webkit-text-size-adjust: 100%;
  }
</style>
